import { render, staticRenderFns } from "./SearchTeachers.vue?vue&type=template&id=4ebad75e&scoped=true&"
import script from "./SearchTeachers.vue?vue&type=script&lang=ts&"
export * from "./SearchTeachers.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTeachers.vue?vue&type=style&index=0&id=4ebad75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebad75e",
  null
  
)

export default component.exports